import { CiapSelectFieldModel } from 'components/form/field/select/CiapSelectField/CiapSelectField'
import { CidSelectFieldModel } from 'components/form/field/select/CidSelectField/CidSelectField'
import { Ciap, Cid10 } from 'graphql/types.generated'

export const formatCidOrCiap = (
  cid: Cid10 | CidSelectFieldModel | undefined | null,
  ciap: Ciap | CiapSelectFieldModel | undefined | null
): string => {
  const cidNome = cid?.nome
  const cidCodigo = cid?.codigo

  if (cidNome && cidCodigo) {
    return `${cidNome} - ${cidCodigo} (CID 10)`
  }

  const ciapDescricao = ciap?.descricao
  const ciapCodigo = ciap?.codigo

  if (ciapDescricao && ciapCodigo) {
    return `${ciapDescricao} - ${ciapCodigo} (CIAP 2)`
  }

  return '-'
}
